import {ReasonTypeInfoMap, ReasonTypeType, OrderSheetPageSet} from '@web/core/constants'
import {
    sendOrderApplyFailToNelo,
    sendOrderFailToNelo,
    sendOrderFailureToNelo,
    sendOrderInitToNelo,
    sendOrderTryToNelo,
    sendLeaveToNelo,
} from '@web/helpers/nelo'
import {actionLoggerCreator} from '@web/middlewares/logger'

import {CheckoutRootState as RootState} from '../../../interfaces'

const loggerMiddleware = actionLoggerCreator<RootState>({
    callbackLeaveAction: ({state, action, path, type}) => {
        sendLeaveToNelo({
            entry: state.common.entry,
            pageSet: OrderSheetPageSet.FAMILY_PAY,
            orderSheetId: state.common.seqID,
            message: action.type,
            type,
            path,
        })
    },
    callbackLogAction: ({state, log}) => {
        if (log.type === 'failure') {
            const {code, message} = log.info
            sendOrderFailureToNelo({
                entry: state.common.entry,
                orderSheetId: state.common.seqID,
                pageSet: OrderSheetPageSet.FAMILY_PAY,
                code,
                message,
            })
        } else if (log.type === 'info') {
            const {message} = log.info
            sendOrderInitToNelo({
                entry: state.common.entry,
                pageSet: OrderSheetPageSet.FAMILY_PAY,
                message,
            })
        } else if (log.type === 'orderTry') {
            const {code} = log.info
            sendOrderTryToNelo({
                entry: state.common.entry,
                code,
                orderSheetId: state.common.seqID,
                pageSet: OrderSheetPageSet.FAMILY_PAY,
            })
        } else if (log.type === 'orderFail') {
            const {orderProcessId, orderNo, code, message} = log.info
            sendOrderFailToNelo({
                entry: state.common.entry,
                orderNo,
                orderProcessId,
                code,
                message,
                orderSheetId: state.common.seqID,
                pageSet: OrderSheetPageSet.FAMILY_PAY,
                level: ReasonTypeInfoMap[code as ReasonTypeType]?.level ?? 'ERROR',
            })
        } else if (log.type === 'orderApplyFail') {
            const {orderNo, orderSheetId, orderProcessId, code, message, pageSet} = log.info
            sendOrderApplyFailToNelo({
                entry: state.common.entry,
                orderNo,
                orderSheetId,
                orderProcessId,
                code,
                message,
                pageSet,
                level: code ? (ReasonTypeInfoMap[code as ReasonTypeType]?.level ?? 'ERROR') : 'ERROR',
            })
        }
    },
})

export default loggerMiddleware
